var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_4",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.702
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(-52 -588)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 52, 588)",
    filter: "url(#Ellipse_4)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4-2",
    "data-name": "Ellipse 4",
    cx: 27,
    cy: 27,
    r: 27,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-github",
    "data-name": "Icon awesome-github",
    d: "M8.7,21.5c0,.108-.121.194-.273.194-.173.016-.294-.07-.294-.194,0-.108.121-.194.273-.194C8.56,21.288,8.7,21.374,8.7,21.5Zm-1.63-.242c-.037.108.068.231.225.263a.243.243,0,0,0,.325-.108c.031-.108-.068-.231-.225-.28A.266.266,0,0,0,7.066,21.256Zm2.317-.091c-.152.038-.257.14-.241.263.016.108.152.177.309.14s.257-.14.241-.247S9.535,21.148,9.383,21.164ZM12.832.563A12.733,12.733,0,0,0,0,13.681a13.459,13.459,0,0,0,8.885,12.86c.671.124.907-.3.907-.651,0-.333-.016-2.172-.016-3.3,0,0-3.669.806-4.44-1.6,0,0-.6-1.564-1.457-1.968,0,0-1.2-.844.084-.828a2.756,2.756,0,0,1,2.023,1.387A2.733,2.733,0,0,0,9.808,20.7a3.018,3.018,0,0,1,.839-1.812c-2.93-.333-5.887-.769-5.887-5.941A4.128,4.128,0,0,1,6,9.783a5.2,5.2,0,0,1,.136-3.65c1.1-.349,3.617,1.452,3.617,1.452a12.085,12.085,0,0,1,6.584,0s2.521-1.806,3.617-1.452a5.2,5.2,0,0,1,.136,3.65,4.228,4.228,0,0,1,1.352,3.167c0,5.188-3.087,5.6-6.018,5.941a3.223,3.223,0,0,1,.891,2.495c0,1.812-.016,4.054-.016,4.495,0,.349.241.774.907.651A13.338,13.338,0,0,0,26,13.681,13.01,13.01,0,0,0,12.832.563ZM5.1,19.105c-.068.054-.052.177.037.28.084.086.2.124.273.054.068-.054.052-.177-.037-.28C5.284,19.073,5.163,19.035,5.1,19.105Zm-.566-.435c-.037.07.016.156.121.21a.154.154,0,0,0,.225-.038c.037-.07-.016-.156-.121-.21C4.65,18.6,4.566,18.616,4.529,18.67Zm1.7,1.914c-.084.07-.052.231.068.333.121.124.273.14.341.054.068-.07.037-.231-.068-.333C6.453,20.514,6.3,20.5,6.227,20.584Zm-.6-.79c-.084.054-.084.194,0,.317s.225.177.294.124a.25.25,0,0,0,0-.333C5.85,19.777,5.714,19.723,5.63,19.793Z",
    transform: "translate(75 607.438)",
    fill: "#b36705"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.7fa3331917ed80339eb21199052874bd.svg";
export { ForwardRef as ReactComponent };